export const pickupLocationTypeOptions: string[] = [
    'Hospital',
    'Nursing Home',
    'Residence',
    'Morgue',
    'Hospice',
    'Another Funeral Home',
];
